import { assign, createMachine } from "xstate";
import { fetchUserData } from "@nju/data-access-dev-tip";

interface IContext {
  userId?: string;
  userDigits?: string;
}

type IEvent =
  | {
      type: "FETCH_USER_DIGITS";
    }
  | {
      type: "FETCH_USER_DIGITS_SUCCESS";
      userDigits: string | undefined;
    }
  | {
      type: "FETCH_USER_DIGITS_ERROR";
    };

export const verificationDataMachine = createMachine<IContext, IEvent>(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "init",
    states: {
      init: {
        on: {
          FETCH_USER_DIGITS: {
            target: "loading",
          },
        },
      },
      loading: {
        invoke: {
          src: "fetchUserDigits",
        },
        on: {
          FETCH_USER_DIGITS_SUCCESS: {
            actions: "setUserDigits",
            target: "init",
          },
          FETCH_USER_DIGITS_ERROR: {
            target: "init",
          },
        },
      },
    },
  },
  {
    actions: {
      setUserDigits: assign<IContext, IEvent>((context, event: IEvent) => {
        if (event.type === "FETCH_USER_DIGITS_SUCCESS") {
          return {
            userDigits: event.userDigits,
          };
        }

        return context;
      }),
    },
    services: {
      fetchUserDigits: (context) => {
        return async (callback) => {
          try {
            const result = (await fetchUserData(context.userId)).unwrap();

            callback({
              type: "FETCH_USER_DIGITS_SUCCESS",
              userDigits: result.person.registrations?.[0].id.slice(-4),
            });
          } catch {
            callback({
              type: "FETCH_USER_DIGITS_ERROR",
            });
          }
        };
      },
    },
  },
);
